/**
 * 新增 编辑
 * @author 3173
 * @description  新增/编辑
 * @Date  2020/9/28
 */
import React, { Component } from 'react';
import {Card, Form,Divider} from 'antd'
import { component_tool, framework_tool ,utils_tool} from '@/tool'
import { WizTableForm, WizClassifySelectRe, WizAuthority ,WizDataAuthSelect} from '@/containers/common';
import '@/styles/containers/online/live/style.less';
import moment from "moment";
import LiveNotice from "./liveNotice";
const { isType } = utils_tool
let {  getPageData } = utils_tool;

let { WizAvatarUpload, ossFileUtils, WizFileUpload } = framework_tool
import { AudienceGroupItem } from '@/components';

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert,
  WizTreeSelect,
  WizModal,
  WizDataTable
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

const validator = (rule, value, callback) => {
  if (value) {
      if (value.groupId) {
        callback()
        return
      }
      if (value.orgIds && value.orgIds.length) {
          callback()
          return
      }
      if (value.positionIds && value.positionIds.length) {
          callback()
          return
      }
      if (value.positionCategoryIds && value.positionCategoryIds.length) {
          callback()
          return
      }
      if (value.personIds && value.personIds.length) {
          callback()
          return
      }
  }
  callback('请选择直播受众')
}




/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class LiveForm extends Component {

  constructor(props) {
    super(props);
    let { initialValue } = props;
    this.state = {
      type: initialValue && initialValue.liveType ? initialValue.liveType : 1,
      videoTool:initialValue && initialValue.videoTool ? initialValue.videoTool : 2,
      wizAuthorityKey: 'wizAuthorityKey',//用于处理wizAuthority组件重置不生效问题
      showNoticeStart : true,
      showNoticeEnd : true,
      liveNoticeVisible:false,
      dataItems: initialValue && initialValue.templateInfoList && initialValue.templateInfoList.length ? initialValue.templateInfoList:[],
      showAuthVisible:false,
      scope: {},
      actionType: 'add', // 消息操作类型,add,upd,默认新增add
      noticeInitInfo:{},
      hostName : initialValue && initialValue.personInfo && initialValue.personInfo[0] ? initialValue.personInfo[0].fullName : ""
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
    this.clearWizCallBack = [];
  }


  /**上传校验 */
  _ossBeforeUpload(file) {
    let result = true;
    // if (file.type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') == -1) {
    //   Wizmessage.error('只能上传xlsx文件,请重新选择!');
    //   result = false;
    // }
    this.setState({
      fileId: undefined,
      file: file,
    }, () => {
      //要做的事情
    }
    )
    return result;
  }

  /** 上传的文件显示内容 */
  _fileChildren() {
    let icon = <WizIcon type="loading" style={{ fontSize: 14 }} />
    let fileName = ''
    if (this.state.file && this.state.file.fileOriginalName) {
      icon = <WizIcon type="paper-clip" />;
      fileName = this.state.file.fileOriginalName;
    } else if (this.state.file && this.state.file.name) {
      fileName = this.state.file.name;
    }
    //anticon anticon-loading
    return (
      <>
        <WizButton><WizIcon type="upload" /> 选择文件</WizButton>
        {
          this.state.file ?
            <div class=" ant-upload-list ant-upload-list-text">
              <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                <div class="ant-upload-list-item-info">
                  {icon}
                  <span class="ant-upload-list-item-name ant-upload-list-item-name-icon-count-2"> {fileName} </span>
                </div>
              </div>
              {/* <WizProgress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} status="active" percent={99.9} showInfo={false}/> */}
            </div> : <></>
        }
      </>
    )
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips} >
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const { getFieldDecorator,getFieldValue } = this.props.form;
    let personIdList = [];
    let personInfoAuth = this.initialValue.authInfo && this.initialValue.authInfo.personIds;
    let personInfoAuthNew = [];
    if (personInfoAuth && personInfoAuth instanceof Array && personInfoAuth.length>0){
      personInfoAuth.forEach(personInfo => {
        const {id} = personInfo;
        personIdList.push(id);
        personInfoAuthNew.push({key:id,...personInfo})
      })
    }
    let base01 = [
      <Item label="直播名称">
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入直播名称' }],
          initialValue: this.initialValue.name,
        })(<WizInput maxLength={33} placeholder='请输入直播名称,最多输入33个字' 
            onBlur={()=>{
              let dataItems = this.state.dataItems
              let dataItemsNew = []
              dataItems.length && dataItems.forEach(e=>{
                  //未发送时名称编辑,在短信列表需要做替换
                  if(e.sendState===0){
                    let templateContent = e.templateContent
                    if(templateContent.indexOf("${liveName}")!=-1 && getFieldValue('name')){
                      templateContent = templateContent.replace(/\$\{liveName\}/g, getFieldValue('name'));
                      e.content = templateContent
                    }
                  }
                  dataItemsNew.push(e);
                  //JSON.parse(JSON.stringify(e.templateContent))
              })
              this.setState({dataItems:dataItemsNew})
            }}
        />)}
      </Item>,
      <Item label="开播时间">
        {getFieldDecorator('startDate', {
          rules: [{ required: true, message: '请选择开播时间', }],
          initialValue: this.initialValue.startDate,
          onChange : (form,value,label,extra)  => {
            if(value){
              this.setState({
                showNoticeStart : true
              })
            }else{
              this.setState({
                showNoticeStart : false
              })
            }
            let startDate = value;
            let endDate = this.props.form.getFieldValue('endDate') ? moment(this.props.form.getFieldValue('endDate')).format('YYYY-MM-DD HH:mm:ss') : undefined;
            let ownerId = this.initialValue.ownerId;
            // type ： 0:zoom资源帐户；1：中目资源帐户
            // liveType：4 远程认证 5 直播课堂 6远程评估
            let type = this.initialValue.liveType === 5 || this.initialValue.liveType === 4 ? 2 : this.initialValue.liveType ===6 ? 1 : undefined;
            let videoTool = this.initialValue && this.initialValue.videoTool ? this.initialValue.videoTool : 2;
            if((type===2 || type===1) && startDate && endDate && this.props.checkMeetingDate){
              startDate = startDate+":00"
              this.props.checkMeetingDate(startDate,endDate,ownerId,type,videoTool)
            }
          },
        })(<WizDatePicker key='startDate' showTime placeholder="请选择开播时间" format="YYYY-MM-DD HH:mm:ss"	 />)}
      </Item>,

      <Item label="结束时间" layout="inline" style={{width: '100%' }}>
        <Item colon={false} style={{ marginBottom: 0, display: 'inline-block', width: '30%' }}>{getFieldDecorator('endDate', {
          rules: [{ required: true, message: '请选择结束时间', }],
          initialValue: this.initialValue.endDate,
          onChange : (form,value,label,extra)  => {
            if(value){
              this.setState({
                showNoticeEnd : true
              })
            }else{
              this.setState({
                showNoticeEnd : false
              })
            }
            let endDate = value;
            let startDate = this.props.form.getFieldValue('startDate') ? moment(this.props.form.getFieldValue('startDate')).format('YYYY-MM-DD HH:mm:ss') : undefined;
            let ownerId = this.initialValue.ownerId;
            // type ： 0:zoom资源帐户；1：中目资源帐户
            // liveType：4 远程认证 5 直播课堂 6远程评估
            let type = this.initialValue.liveType === 5 || this.initialValue.liveType === 4 ? 2 : this.initialValue.liveType ===6 ? 1 : undefined;
            let videoTool = this.initialValue && this.initialValue.videoTool ? this.initialValue.videoTool : 2;
            if((type===2 || type===1) && startDate && endDate && this.props.checkMeetingDate){
              endDate = endDate+":00"
              this.props.checkMeetingDate(startDate,endDate,ownerId,type,videoTool)
            }
          },
        })(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" format="YYYY-MM-DD HH:mm:ss" 	/>)}</Item>
        {this.props.checkDateInfo && this.state.showNoticeStart && this.state.showNoticeEnd ?<Item  style={{ marginBottom: 0, display: 'inline-block', marginLeft: '5%', }}
        >
          <font style={{'color':'red'}}>剩余资源提醒:{this.props.checkDateInfo} </font>
        </Item> : undefined }
      </Item>,
      <Item label="直播类型" >
        {getFieldDecorator('liveType', {
          initialValue: this.initialValue.liveType ? this.initialValue.liveType : 1
        })(
          <WizRadio.Group 
                          //disabled={(this.initialValue.id!=null && this.initialValue.id!=undefined) ? true : false}
                          disabled={true}
                          onChange={(e) => {
                            this.setState({ type: e.target.value,wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime() })
                            this.props.form.setFieldsValue({
                              authCmd:{},
                            })
                          }} >
            <WizRadio value={1}>视频直播</WizRadio>
            {/* <WizRadio value={2}>互动直播</WizRadio>
            <WizRadio value={3}>点播</WizRadio> */}
            <WizRadio value={4}>远程认证</WizRadio>
            <WizRadio value={5}>直播课堂</WizRadio>
            <WizRadio value={6}>远程评估</WizRadio>
            <WizRadio value={7}>企微会议</WizRadio>
            <WizRadio value={8}>企微直播</WizRadio>
          </WizRadio.Group>
        )}
      </Item>,
    ];
    let zoomBase = [];
    if (this.state.type!=null && (this.state.type===4 || this.state.type===5 || this.state.type===6)){
      zoomBase = this._videoToolInteractLive();
    }
    let base02 = [<Item label="观看类型" >
      {getFieldDecorator('watchType', {
        initialValue: this.initialValue.watchType ? this.initialValue.watchType : 1
      })(
        <WizRadio.Group>
          <WizRadio value={1}>横屏</WizRadio>
          <WizRadio value={2}>竖屏</WizRadio>
        </WizRadio.Group>
      )}
    </Item>];
    if (this.state.type == 1) {
      base02 = base02.concat([<Item label="视频直播类型" >
        {getFieldDecorator('liveVideoType', {
          initialValue: this.initialValue && this.initialValue.liveVideoType !==null && this.initialValue.liveVideoType !== undefined
          && this.initialValue.liveVideoType !=='null' &&  this.initialValue.liveVideoType === 4 ? 4 : 1
        })(
          <WizRadio.Group disabled={(this.initialValue.id!=null && this.initialValue.id!=undefined) ? true : false}>
            <WizRadio value={1}>大型直播</WizRadio>
            <WizRadio value={4}>虚拟直播</WizRadio>
          </WizRadio.Group>
        )}
      </Item>]);
    }
    if (this.state.type != 4) {
      base02 = base02.concat([<Item label="直播分类">
        {getFieldDecorator('liveCategoryId', {
          rules: [{ type: 'array' }, { required: true, message: '请选择直播分类' }],
          initialValue: this.initialValue.liveCategoryId ? [this.initialValue.liveCategoryId] : [],
        })(
          <WizClassifySelectRe
            returnKey={true}
            apiProps={{ type: 9, state: 1 }}
            initSelects={this.initialValue.categoryInfo ? this.initialValue.categoryInfo : []}
            wizTreeSelectListProps={{
              itemProps: {
                icon: 'unordered-list',
                title: '直播分类',
                tips: '请选择直播分类'
              },
              multiple: false,
              treeCheckable: false,
              checkable: false,
              showSelectList: true,
              treeProps: { checkStrictly: true }
            }}
            onChange={(e) => {}}
            onClearWiz={this._onClearWiz.bind(this)} />
        )}
      </Item>]);
    }
    let authBase = [];
    if (this.state.type!=null && this.state.type===4){
      //直播课堂、远程评估 多选择人  不能超过25人
      authBase = [
        <Item label="直播受众" required >
          {getFieldDecorator('authCmd', {
            rules: [{ required: true, message: '请选择直播受众', }],
            initialValue: personIdList,
          })(<WizTableForm key={this.state.wizAuthorityKey}
                           {...WizTableForm.Config.user(this, { apiParams: { state: 1 } })} selectType={"radio"} onClearWiz={this._onClearWiz.bind(this)}
                           initRows={personInfoAuthNew} />)}
        </Item>
      ];
    }else if (this.state.type!=null && (this.state.type===5 || this.state.type===6)){
      //远程认证 单选人
      authBase = [
        <Item label="直播受众" required >
          {getFieldDecorator('authCmd', {
            rules: [{ required: true, message: '请选择直播受众', }],
            initialValue: personIdList,
          })(<WizTableForm key={this.state.wizAuthorityKey}
                           {...WizTableForm.Config.user(this, { apiParams: { state: 1 } })} onClearWiz={this._onClearWiz.bind(this)}
                           initRows={ personInfoAuthNew} />)}
        </Item>
      ]
    }else {
      authBase = [
        <Item label="直播受众" >
          {getFieldDecorator('authCmd', {
            initialValue: Object.assign({}, this.initialValue.authInfo) ,
            rules: [{ required: true,validator }],
          })(
            <WizDataAuthSelect key={'WizDataAuthSelect_001'} 
                              //  bizType={26}
                              //  bizId={this.initialValue && this.initialValue.id}
            />
          )}
        </Item>
      ]
    }
    let allBase = [...base01,...zoomBase,...base02,...authBase];
    return allBase
  }


  /**
   *  直播工具相关属性设置
   *  Item hasFeedback 展示校验状态图标
   */
  _videoToolInteractLive() {
    const { getFieldDecorator,setFieldsValue } = this.props.form;
    let items = [];
    // if (this.state.type!=null && (this.state.type===5 || this.state.type===4)){
    //   items = items.concat([
    //     <Item label="视频工具" >
    //       {getFieldDecorator('videoTool', {
    //         initialValue: this.initialValue.videoTool ? this.initialValue.videoTool : 1
    //       })(
    //         <WizRadio.Group disabled={(this.initialValue.id!=null && this.initialValue.id!=undefined) ? true : false} onChange={(e) => {
    //           this.setState({ videoTool: e.target.value})
    //           if(e.target.value==2){
    //             setFieldsValue({
    //               'lookingBack': 0
    //           });
    //           }
    //         }}>
    //           <WizRadio value={2}>慧课堂</WizRadio>
    //           <WizRadio value={1}>中目</WizRadio>
    //         </WizRadio.Group>
    //       )}
    //     </Item>,
    //   ]);
    // }
    if(this.state.type!=4){
      items = items.concat([
        <Item label="直播设置">
          <WizButton title="恢复默认设置" size='small' onClick={e => {
            this._changeInteractLiveValue()
          }}>恢复默认设置</WizButton>
        </Item>
      ])
      if (this.state.type!=null && (this.state.type===5 )&& this.state.videoTool===2){
        items = items.concat(this._hktProperty())
      }else {
        items = items.concat(this._zoomProperty())
      }
    }
    return items
  }

  /**
   * 中目属性设置
   * @returns {*[]}
   * @private
   */
  _zoomProperty(){
    const { getFieldDecorator } = this.props.form;
    const formItemTitleLayout = {
      wrapperCol: { span: 16, offset: 4 },
    };
    return [<Item {...formItemTitleLayout}>
      <Card>
        <WizRow className='row-live-form-style' style={{marginTop: 10, marginBottom: 10}}>
          <WizCol span={5} className='item-form-title' style={{textAlign: 'right'}}>{'是否自动录制：'}</WizCol>
          <WizCol span={6} className='item-content'>
            {getFieldDecorator('autoRecording', {
              initialValue: this.initialValue.autoRecording ? this.initialValue.autoRecording : 0
            })(
              <WizRadio.Group>
                <WizRadio value={1}>是</WizRadio>
                <WizRadio value={0}>否</WizRadio>
              </WizRadio.Group>
            )}
            <WizTooltip title="是否系统自动录制视频">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </WizCol>
          <WizCol span={6} className='item-form-title' style={{textAlign: 'right'}}
                  offset={1}>{'讲师视频：'}</WizCol>
          <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
            {getFieldDecorator('hostVideo', {
              initialValue: this.initialValue.hostVideo ? this.initialValue.hostVideo : 0
            })(
              <WizRadio.Group>
                <WizRadio value={1}>是</WizRadio>
                <WizRadio value={0}>否</WizRadio>
              </WizRadio.Group>
            )}
            <WizTooltip title="讲师进入课堂时是否打开摄像头">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </WizCol>
        </WizRow>
        <WizRow className='row-live-form-style' style={{marginTop: 10, marginBottom: 10}}>
          <WizCol span={5} className='item-form-title' style={{textAlign: 'right'}}>{'学员视频：'}</WizCol>
          <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
            {getFieldDecorator('participantVideo', {
              initialValue: this.initialValue.participantVideo ? this.initialValue.participantVideo : 0
            })(
              <WizRadio.Group>
                <WizRadio value={1}>是</WizRadio>
                <WizRadio value={0}>否</WizRadio>
              </WizRadio.Group>
            )}
            <WizTooltip title="学员进入课堂时是否打开摄像头">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </WizCol>
          <WizCol span={6} className='item-form-title' style={{textAlign: 'right'}}
                  offset={1}>{'是否开启等候室：'}</WizCol>
          <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
            {getFieldDecorator('waitingRoom', {
              initialValue: this.initialValue.waitingRoom ? this.initialValue.waitingRoom : 0
            })(
              <WizRadio.Group>
                <WizRadio value={1}>是</WizRadio>
                <WizRadio value={0}>否</WizRadio>
              </WizRadio.Group>
            )}
            <WizTooltip title="等候室,学员进入课堂时，将他们放在等候室中，并要求讲师单独接受。启用等候室会自动禁用允许学员先进入课堂的设置">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </WizCol>
        </WizRow>
        <WizRow className='row-live-form-style' style={{marginTop: 10, marginBottom: 10}}>
          <WizCol span={5} className='item-form-title' style={{textAlign: 'right'}}>{'进入静音：'}</WizCol>
          <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
            {getFieldDecorator('muteUponEntry', {
              initialValue: this.initialValue.muteUponEntry ? this.initialValue.muteUponEntry : 0
            })(
              <WizRadio.Group>
                <WizRadio value={1}>是</WizRadio>
                <WizRadio value={0}>否</WizRadio>
              </WizRadio.Group>
            )}
            <WizTooltip title="学员进入课堂时是否默认静音">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </WizCol>
          <WizCol span={6} className='item-form-title' style={{textAlign: 'right'}}
                  offset={1}>{'学员先进入课堂：'}</WizCol>
          <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
            {getFieldDecorator('joinBeforeHost', {
              initialValue: this.initialValue.joinBeforeHost ? this.initialValue.joinBeforeHost : 0
            })(
              <WizRadio.Group>
                <WizRadio value={1}>是</WizRadio>
                <WizRadio value={0}>否</WizRadio>
              </WizRadio.Group>
            )}
            <WizTooltip title="当老师未进入课堂时,是否允许学员先进入">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </WizCol>
        </WizRow>
      </Card>
    </Item>];
  }

  /**
   * 慧课堂属性设置
   * @returns {*[]}
   * @private
   */
  _hktProperty(){
    const formItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 24,
          offset: 6,
        }
      },
      style:{
        marginBottom:0,
        marginTop:0
      }
    };
    const { getFieldDecorator,getFieldValue } = this.props.form;
    return [<Item {...formItemLayout} label="" required>
      {getFieldDecorator('isHostCamera', {
        initialValue: this.initialValue.isHostCamera ? [1] : [0]
      })(
        <WizCheckbox.Group>
          <WizCheckbox value={1}>主持人进课堂开启摄像头</WizCheckbox>
        </WizCheckbox.Group>,
      )}
    </Item>,
      <Item {...formItemLayout} label="" required>
        {getFieldDecorator('isHostMic', {
          initialValue: this.initialValue.isHostMic ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>主持人进课堂开启麦克风</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
      <Item {...formItemLayout} label="" required>
        {getFieldDecorator('isParticipantPlatform', {
          initialValue: this.initialValue.isParticipantPlatform==undefined || this.initialValue.isParticipantPlatform ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>参与者进课堂时在讲台上</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
getFieldValue('isParticipantPlatform') && getFieldValue('isParticipantPlatform')[0]?
[
<Item {...formItemLayout} label="" required>
        {getFieldDecorator('isAllowCamera', {
          initialValue: this.initialValue.isAllowCamera==undefined || this.initialValue.isAllowCamera ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者允许开启摄像头</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
      <Item {...formItemLayout} label="" required>
        {getFieldDecorator('isParticipantCamera', {
          initialValue: this.initialValue.isParticipantCamera ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者开启摄像头</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
      <Item {...formItemLayout} label="" required>
        {getFieldDecorator('isAllowMic', {
          initialValue: this.initialValue.isAllowMic==undefined || this.initialValue.isAllowMic ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者允许开启麦克风</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
      <Item {...formItemLayout} label="" required>
        {getFieldDecorator('isParticipantMic', {
          initialValue: this.initialValue.isParticipantMic ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者开启麦克风</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
]:null,
      
      <Item {...formItemLayout} label="" required>
        {getFieldDecorator('isFollowHost', {
          initialValue: this.initialValue.isFollowHost ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>所有人跟随主持人</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
    ];
  }

  /**点播的数据 */
  _onDeman() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Item label="视频文件" >
        {getFieldDecorator('videoFile', {
          rules: [{ required: true, message: '请上传视频文件' }],
          initialValue: (this.initialValue && this.initialValue.videoFile) ? [
            ossFileUtils.getOssFile(
              this.initialValue.videoFile, this.initialValue.videoFileName, this.initialValue.videoFileMimeType, this.initialValue.videoFileSize, this.initialValue.videoFileUri,
            )
          ] : [],
        })(
          <WizFileUpload
            accept={'.mp4'}
            beforeUpload={this._ossBeforeUpload.bind(this)}
            children={this._fileChildren()}
            showUploadList={false}
            uploadType={'system'}
          />
        )}
      </Item>)
  }

  /**直播的数据 */
  _liveBroadcast() {
    const { getFieldDecorator } = this.props.form;
    const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole" } })
    let items = [
      <Item label="讲师"  >
        {getFieldDecorator('hostId', {
         // rules: [{ required: true, message: '请选择讲师', }],
          initialValue: this.initialValue.hostId,
        })(<WizTableForm {...userConfig} selectType={"radio"} title="选择讲师" onClearWiz={this._onClearWiz.bind(this)}
          onChangeRowMap = {(data)=>{
            if (data && isType(data, 'Object')) {
              for (let [key, value = {}] of Object.entries(data)) {
                let {
                  fullName = '',
                } = value
                this.setState({hostName:fullName})
              }
            }
          }}
          disabled={(this.initialValue.state == 3 || this.initialValue.state == 4) ? true : false} initRows={this.initialValue.personInfo ? this.initialValue.personInfo : []} />)}
      </Item>,
      <Item label="主讲人" >
        {getFieldDecorator('speaker', {
          initialValue: this.initialValue.speaker
        })(
          <WizInput maxLength={50} placeholder={'请输入主讲人'} />
        )}
      </Item>,
      <Item label="是否可回看" >
        {getFieldDecorator('lookingBack', {
          initialValue: this.initialValue.lookingBack || this.initialValue.lookingBack==0 ? this.initialValue.lookingBack : 1
        })(
          <WizRadio.Group disabled={this.state.videoTool==2}>
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>
    ];
    return items
  }

  /**
   * 企微会议/企微直播
   */
  _qyWeiXinLive() {
    const { getFieldDecorator } = this.props.form;
    const userConfig = WizTableForm.Config.user2(this, { apiParams: { state: 1 } })

    return (
      <Item label="讲师" required >
        {getFieldDecorator('hostId', {
          rules: [{ required: true, message: '请选择讲师', }],
          initialValue: this.initialValue.hostId,
        })(<WizTableForm {...userConfig} selectType={"radio"} key={'qy-weixin-live-'+this?.state?.type} title="选择讲师" onClearWiz={this._onClearWiz.bind(this)} initRows={this.initialValue.personInfo ? this.initialValue.personInfo : []} />)}
      </Item>
    )
  }

  showAuthModal = (e, text = {}) => {
    e.stopPropagation()
    this.setState({ showAuthVisible: true, scope: text });
  };

  _updateNotice=(record)=>{
    this.setState({
      noticeInitInfo : record,
      actionType:'upd',
      liveNoticeVisible:true
    })
  }
  
  _deleteNotice=(record)=>{
    let {dataItems} = this.state
    let dataItemsNew = []
    dataItems.forEach(e=>{
      let rowKey = record.rowKey ? record.rowKey : record.templateDefineId
      if(e.templateDefineId==rowKey || e.rowKey==rowKey){
        //
      }else{
        dataItemsNew.push(e);
      }
    })
    this.setState({dataItems:dataItemsNew})
    //维护消息列表数据
    //templateInfoList
    this.props.form.setFieldsValue({
      templateInfoList:dataItemsNew,
    })
  }

  _notice= () => {
    const { getFieldDecorator,getFieldValue } = this.props.form;
    let columns = [
      {
        title: "短信内容",
        name: "content",
        dataIndex: "content",
        tableItem: {
          width: 350,
          render: (text, record) => {
            let textNew = record.templateContent;
            if(record.sendState==0){
              if(textNew.indexOf("${name}")!=-1 && this.state.hostName ){
                textNew = textNew.replace(/\$\{name\}/g, this.state.hostName);
              }
              if(textNew.indexOf("${liveName}")!=-1 && getFieldValue("name") ){
                textNew = textNew.replace(/\$\{liveName\}/g, getFieldValue("name"));
              }
              if(textNew.indexOf("${startTime}")!=-1 && getFieldValue("startDate")){
                textNew = textNew.replace(/\$\{startTime\}/g, moment(getFieldValue("startDate")).format("YYYY-MM-DD HH:mm"));
              }
              if(textNew.indexOf("${endTime}")!=-1 && getFieldValue("endDate")){
                textNew = textNew.replace(/\$\{endTime\}/g, moment(getFieldValue("endDate")).format("YYYY-MM-DD HH:mm"));
              }
            }else{
              textNew = record.realContent
              // if(text.indexOf("${name}")!=-1 && this.initialValue.personInfo && this.initialValue.personInfo[0] && this.initialValue.personInfo[0].fullName ){
              //   text = text.replace(/\$\{name\}/g, this.initialValue.personInfo[0].fullName);
              // }
              // if(text.indexOf("${liveName}")!=-1 && this.initialValue.name ){
              //   text = text.replace(/\$\{liveName\}/g, this.initialValue.name);
              // }
              // if(text.indexOf("${startTime}")!=-1 && this.initialValue.startDate){
              //   text = text.replace(/\$\{startTime\}/g, moment(this.initialValue.startDate).format("YYYY-MM-DD HH:mm"));
              // }
              // if(text.indexOf("${endTime}")!=-1 && this.initialValue.endDate){
              //   text = text.replace(/\$\{endTime\}/g, moment(this.initialValue.endDate).format("YYYY-MM-DD HH:mm"));
              // }
            }
            return <div>{textNew}</div>
          }
        },
      },
      {
        title: "短信受众",
        name: "authCmd",
        dataIndex: "authCmd",
        tableItem: {
          width: 100,
          render: (text, record) => {
            return <a onClick={(e) => this.showAuthModal(e, text? text : record.authInfo)}>查看受众</a>
          }
        },
      },
      {
        title: "短信发送时间",
        name: "assignTime",
        dataIndex: "assignTime",
        tableItem: {
          width: 180,
          render: (text, record) => {
            return <div>{moment(text).format("YYYY-MM-DD HH:mm")}</div>
          }
        },
      },
      {
        title: "发送状态",
        name: "sendState",
        dataIndex: "sendState",
        tableItem: {width: 100,},
        dict: [
          {code: 1, codeName: "已发送"},
          {code: 0, codeName: "未发送"}
        ],
      },
      {
        title: "过滤已参训人员",
        name: "filterParticipants",
        dataIndex: "filterParticipants",
        tableItem: {width: 130,},
        dict: [
          {code: 1, codeName: "是"},
          {code: 0, codeName: "否"}
        ],
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        tableItem: {
          width: 150,
          render: (text, record) => {
            return <span>
               <a disabled={record.sendState} onClick={()=>{this._updateNotice(record)}}>编辑</a>
               <Divider type="vertical" />
               <a disabled={record.sendState} onClick={()=>{this._deleteNotice(record)}}>删除</a>
             </span>
           },
        },
      },
    ]

    const dataTableProps = {
      key:'auth_dataTable', 
      columns: columns, 
      rowKey: 'rowKey', 
      dataItems: getPageData({records: this.state.dataItems}),
      style:{marginTop:'15px'} 
    }

    return (
      getFieldValue('liveType')==1 ? 
      <>
        <Item label="是否需要短信" >
        {getFieldDecorator('isMessage', {
          initialValue: this.initialValue.isMessage == 1 ? 1:0
        })(
          <WizRadio.Group >
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>
      {getFieldValue('isMessage') === 1 ? 
      <Item label="短信通知设置" >
      {getFieldDecorator('templateInfoList', {
        initialValue: this.initialValue.templateInfoList ?this.initialValue.templateInfoList:[] ,
        rules: [{ required: true, message: '请进行短信通知设置', }],
      })(
        <><WizButton disabled={this.state.dataItems.length==2} onClick={()=>{this.setState({noticeInitInfo:{},actionType:'add', liveNoticeVisible:true})}}>新增短信通知</WizButton>
        <WizDataTable {...dataTableProps} />
        </>
      )}
    </Item>
      :<></>}
      
      </> :<></>
    )
  }

  /**
    * 拓展属性
    */
  _ext = () => {
    if (this.state.type === 3) {
      return this._onDeman();
    } else if (this.state.type === 1 || this.state.type === 2 || this.state.type === 4 || this.state.type === 5 || this.state.type === 6) {
      return this._liveBroadcast();
    } else if ([7, 8].indexOf(this.state.type) !== -1) {
      return this._qyWeiXinLive();
    }
    return null;
  }

  _ext2() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Item label="直播封面" >
          {getFieldDecorator('img', {
            initialValue: (this.initialValue && this.initialValue.img) ? [
              // ossFileUtils.getOssFile(
              //   this.initialValue.img, this.initialValue.fileName, this.initialValue.fileMimeType, this.initialValue.fileSize, this.initialValue.fileUri,// fileId: this.initialValue.img
              // )
              {fileId:this.initialValue.img}
            ] : [],
          })(
            <WizAvatarUpload
              accept={'.jpg, .jpeg, .png'}
              listType={'picture-card'}
              aspectRatio={2 / 1}
              beforeUpload={(file) => {
                let result = true;
                const isLt1M = file.size / 1024 / 1024 < 0.195;
                if (file.type.indexOf('image/') == -1) {
                  Wizmessage.error('只能上传图片类型,请重新选择!');
                  result = false;
                } else if (!isLt1M) {
                  Wizmessage.error('图片不得超过200k!');
                  result = false;
                }
                return result;
              }}
            />
          )}
        </Item>
        <Item label="是否允许匿名互动" >
        {getFieldDecorator('anonymous', {
          initialValue: this.initialValue.anonymous == 1 ? 1:0
        })(
          <WizRadio.Group>
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>
        <Item label="介绍" >
          {getFieldDecorator('intro', {
            initialValue: this.initialValue.intro
          })(
            <WizInput.TextArea rows={4} maxLength={200} placeholder={'请输入介绍'} />
          )}
        </Item>
      </>
    )
  }


  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{ span: 12, offset: 6 }}>
        <WizRow>
          <WizCol span={24} style={{ textAlign: 'center' }}>
            <WizButton style={{ marginLeft: 20 }} title="保存" type="primary" htmlType="submit">保存</WizButton>
            <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>重置</WizButton>
          </WizCol>
        </WizRow>
      </Item>
    )
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {
          this.props.onSubmit({...values,hostName:this.state.hostName});
        }
      }
    });
  };

  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let type = this.initialValue && this.initialValue.liveType ? this.initialValue.liveType : undefined;
    let videoTool = this.initialValue && this.initialValue.videoTool ? this.initialValue.videoTool  : 2
    let dataItems = this.initialValue && this.initialValue.templateInfoList && this.initialValue.templateInfoList.length ? this.initialValue.templateInfoList : []
    this.setState({
      type: type,
      wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime(),
      videoTool:videoTool,
      dataItems: dataItems
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  /**
   *
   * 设置直播附属信息值,未传则全部设置默认值
   */
  _changeInteractLiveValue = () => {
    this.props.form.setFieldsValue({
      autoRecording: 0,
      hostVideo: 0,
      participantVideo: 0,
      waitingRoom: 0,
      muteUponEntry: 0,
      joinBeforeHost: 0,
      isHostCamera: [0],
      isHostMic: [0],
      isParticipantPlatform: [1],
      // isAllowCamera: [1],
      // isParticipantCamera: [0],
      // isAllowMic: [1],
      // isParticipantMic: [0],
      // isHallMode: [0],
      // isFollowHost: [0],
      // isModifyResume: [0],
    })
    setTimeout(()=>{
      this.props.form.setFieldsValue({
        isAllowCamera: [1],
        isParticipantCamera: [0],
        isAllowMic: [1],
        isParticipantMic: [0],
        isHallMode: [0],
        isFollowHost: [0],
        isModifyResume: [0],
      })
    },0)
  }

  saveLiveNotice=(values)=>{
    let {dataItems,actionType} = this.state
    let dataItemsNew = []
    if(actionType=='add'){
      dataItems.push(values)
      dataItemsNew=dataItems
    }else if(actionType=='upd'){
      dataItems.forEach(e=>{
        if(e.templateDefineId==values.rowKey || e.rowKey==values.rowKey){
          dataItemsNew.push(values);
        }else{
          dataItemsNew.push(e);
        }
      })
    }
    this.setState({liveNoticeVisible: false,dataItems:dataItemsNew})
    //维护消息列表数据
    //templateInfoList
    this.props.form.setFieldsValue({
      templateInfoList:dataItemsNew,
    })
  }

  render() {
    const { getFieldDecorator ,getFieldValue,getFieldsValue} = this.props.form;
    const { title } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    };

    const modalProps = {
      title: '查看受众',
      visible: this.state.showAuthVisible,
      footer: null,
      onCancel: () => {
        this.setState({ showAuthVisible: false })
      }
    }

    return (
      <WizCard title={title} icon='0'>
        <WizForm
          key={this.props.formKey}
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {this._notice()}
          {this._ext()}
          {this._ext2()}
          {this._submit()}
        </WizForm>
        <WizModal destroyOnClose
                  key={new Date().getTime()}
                  width={700} title={"短信通知"}
                  visible={this.state.liveNoticeVisible}
                  footer={null}
                  onCancel={() => {this.setState({liveNoticeVisible: false})}}
                  >
               <LiveNotice noticeInitInfo={this.state.noticeInitInfo}  saveLiveNotice={(values) =>{this.saveLiveNotice(values)}} liveName={getFieldValue("name")} initAuthCmd={JSON.parse(JSON.stringify(getFieldValue("authCmd")))} startTime={getFieldValue("startDate")} endTime={getFieldValue("endDate")} hostName={this.state.hostName}/>
        </WizModal>
        <WizModal {...modalProps}>
              <AudienceGroupItem {...this.state.scope} />
            </WizModal>
      </WizCard>
    )

  }
}

export default WizForm.create()(LiveForm);


